module.exports = __webpack_public_path__ + "viasport-logo-se-black-8a83a491449b94c11616dc37ec03bb84.png";


//////////////////
// WEBPACK FOOTER
// ./assets/viasport-logo-se-black.png
// module id = 953
// module chunks = 0 1 2 5